import { Middleware } from 'redux';
import { hasError } from './slices/users';
import { hasError as hasErrorProduct } from './slices/product';
import { openSnackbar } from './slices/snackbar';

const errorHandlingMiddleware: Middleware = (store) => (next) => (action) => {
    const { dispatch } = store;
    if (action.type === 'menu/activeItem') {
        dispatch(hasError(null));
    }

    if (action.type === 'product/lifecycleapproval/rejected') {
        dispatch(
            openSnackbar({
                message: `An error occurred while fetching approval steps for this merchant`,
                variant: 'error',
                duration: 5000
            })
        );
    }

    if (action.type === 'product/getProductsMulticatalog/rejected') {
        dispatch(hasErrorProduct(action.payload));
    }

    return next(action);
};

export default errorHandlingMiddleware;
